import { defineMessages } from 'react-intl-next';

export const messages: {
	mediaPickerButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	mediaPickerContentHelperMessage: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	mediaPickerContentTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	mediaPickerContentTitle: {
		id: 'company-hub.company-hub-common.spotlight.spotlight-config-panel.media-picker-content-title',
		defaultMessage: 'Media',
		description: 'Title for configuring image in the media picker',
	},
	mediaPickerButtonLabel: {
		id: 'company-hub.company-hub-common.spotlight.spotlight-config-panel.media-picker-button-label',
		defaultMessage: 'Choose media',
		description: 'Button label for configuring image in the media picker',
	},
	mediaPickerContentHelperMessage: {
		id: 'company-hub.company-hub-common.spotlight.spotlight-config-panel.mdia-picker-helper-message',
		defaultMessage: 'Choose high resolution images 1200px or wider for best results.',
		description: 'Helper message for configuring image in the media picker',
	},
});
